
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Text_output2","data-name":"Text output2","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15286","data-name":"Rectangle 15286","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45448","data-name":"Group 45448"}},[_c('g',{attrs:{"id":"Group_45449","data-name":"Group 45449","fill":"#5858ec"}},[_c('path',{attrs:{"id":"Path_32677","data-name":"Path 32677","d":"M5.991 7.5h14.25a.75.75 0 000-1.5H5.991a.75.75 0 000 1.5"}}),_c('path',{attrs:{"id":"Path_32678","data-name":"Path 32678","d":"M5.991 12h9.75a.75.75 0 000-1.5h-9.75a.75.75 0 000 1.5"}}),_c('path',{attrs:{"id":"Path_32679","data-name":"Path 32679","d":"M24.521 13.227l-3.75-3.75a.751.751 0 00-1.06 0l-3.75 3.75a.646.646 0 00-.037.037.75.75 0 101.1 1.023l2.47-2.47v10.19a.75.75 0 001.5 0v-10.19l2.47 2.47a.646.646 0 00.037.037.75.75 0 101.023-1.1"}}),_c('path',{attrs:{"id":"Path_32680","data-name":"Path 32680","d":"M11.411 14.985H6.892A1.552 1.552 0 005.245 16.4v.168a.67.67 0 00.609.726.677.677 0 00.726-.612v-.2a.216.216 0 01.255-.151h1.622v6.325h-.836a.671.671 0 000 1.342h3.014a.671.671 0 000-1.342H9.8v-6.331h1.666a.2.2 0 01.207.154 1.668 1.668 0 000 .2.659.659 0 00.72.583.7.7 0 00.617-.756v-.1a1.538 1.538 0 00-1.6-1.418"}})])])])
          )
        }
      }
    